var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KBreadcrumbs',{attrs:{"items":[
    { text: 'Home', link: { path: '/' } },
    { text: 'Library', link: null },
    { text: 'Category', link: { path: '/category' } },
    { text: 'Subcategory', link: { path: '/subcategory' } },
    { text: 'Files', link: null },
  ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }